import { t } from '@ping/helpers';
import { Text, Button } from '@ping/uikit';
import VerifyOwnershipIcon from '@ping/assets/Icon/verify-ownership.svg';
import CircleWarningIcon from '@ping/assets/Icon/circle-warning.svg';
import Link from 'next/link';

import style from './style.module.scss';
import clsx from 'clsx';

interface IVerifyOwnershipLTCProps {
  onSubmit: () => void;
  className?: string;
  isLoading?: boolean;
}

export const VerifyOwnershipLTC = ({ isLoading, onSubmit, className }: IVerifyOwnershipLTCProps) => {
  return (
    <div className={clsx(style['verifyOwnershipLTC'], className)}>
      <div className={style['verifyOwnershipLTC__content']}>
        <VerifyOwnershipIcon />
        <Text heading='4'>{t('Verify ownership of your external Litecoin wallet address for LTC withdrawals')}</Text>
        <Text cadetBlueColor body='regular'>
          {t(
            'In order to continue, please the proof of ownership declaration in the next step for the wallet address you wish to enable withdrawals for.'
          )}
        </Text>
        <ul>
          <li>
            <Text cadetBlueColor>
              1.{' '}
              {t(
                'You will be required to verify the form and information provided including the address you wish to verify.'
              )}
            </Text>
          </li>
          <li>
            <Text cadetBlueColor>
              2. {t('Scan QR code with your CorePass app and sign the declaration in order to continue')}
            </Text>
          </li>
        </ul>
        <section className={style['verifyOwnershipLTC__notice']}>
          <span className={style['verifyOwnershipLTC__notice-icon']}>
            <CircleWarningIcon />
          </span>
          <div>
            <Text body='semi-bold' className={style['verifyOwnershipLTC__notice-heading']}>
              {t('Important notice')}
            </Text>
            <Text cadetBlueColor caption='regular'>
              {t(
                'Please be aware that each asset (Bitcoin, Ethereum, Litecoin) requires a unique withdrawal address as they operate on different blockchains, necessitating separate verification for each.'
              )}
            </Text>
            <div className={style['verifyOwnershipLTC__notice-link']}>
              <Link href='/user/tiers'>{t('Learn more about supported wallets')}</Link>
            </div>
          </div>
        </section>
      </div>
      <Button
        className={style['verifyOwnershipLTC__button']}
        type='primary'
        design='general'
        size='small'
        uppercase
        htmlType='submit'
        isLoading={isLoading}
        onClick={onSubmit}
      >
        {t('Continue')}
      </Button>
    </div>
  );
};
